const canSpamActUrl = 'https://www.ftc.gov/business-guidance/resources/can-spam-act-compliance-guide-business';

export { canSpamActUrl };